import type { ClikArtPlacedFilter } from './types/clik-art-placed-filter'

/**
 * AND-filters `items` by whether they are already placed on the spread. `'any'` applies no
 * restriction (matching `filterClikArtByCategory`'s `CLIKART_ALL_CATEGORIES_OPTION` behavior).
 * A missing `placedFlag` field is treated as not placed, same as a missing `categoryName` field
 * is treated as not matching in the sibling filter.
 */
export function filterClikArtByPlaced<T extends { placedFlag?: boolean }>(
  items: T[],
  filter: ClikArtPlacedFilter
): T[] {
  if (filter === 'any') return items

  const wantPlaced = filter === 'yes'

  return items.filter((item) => Boolean(item.placedFlag) === wantPlaced)
}
